import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AuthPageContextService {
private imageUrlSubject = new BehaviorSubject<string | null>(null);
  imageUrl$ = this.imageUrlSubject.asObservable();
  

  setImageUrl(url: string): void {
    this.imageUrlSubject.next(url);
  }
}
